export const serverUrl = process.env.REACT_APP_SERVER_URL as string;

const htmlExpression =
  '<i>tg</i><sup> 2</sup>α + 1 = <sup>1</sup>&frasl;<sub><i>cos</i><sup> 2</sup>α</sub>';

export const testQuestions = [
  'Чи любите Ви допомагати іншим людям у вирішення їх проблем?',
  'Чи буває, що Вам здається, ніби Ви  зробили щось не так?',
  'Вам подобається детективний жанр?',
  'Вам подобаються командні ігри?',
  'Вам подобається шкільний предмет "Інформатика"?',
  'Чи можете Ви розрізнити діалекти однієї мови?',
  'Чи маєте Ви здібності до вивчення іноземних мов?',
  'Чи подобаються Вам шкільні предмети зі складними термінами?',
  'Чи швидко Ви пристосовуєтесь до нових життєвих обставин?',
  'Чи легко Вам пояснити іншим свою позицію?',
  'Чи цікавитесь Ви проблемами економіки?',
  `Чи правильна тотожність? ${htmlExpression}`,
  'Чи вмієте Ви заощаджувати?',
  'Чи читали Ви Конституцію Україну?',
  'Чи любите грати в Монополію?',
  'Чи вважаєте Ви за потрібне страхувати своє життя та майно?',
  'Чи можете Ви розподілити свій час?',
  'Чи брали Ви активну участь в учнівському самоврядуванні?',
  'Чи мрійник Ви?',
  'Чи комфортно Вам у компанії з іноземцями?',
  'Чи можете Ви розпланувати Ваше життя на 10 років вперед?',
  'Чи подобається Вам знайомитись з новими людьми?',
  'Чи любите Ви стежити за поведінкою інших?',
  'Чи багато часу Ви проводите в соцмережах?',
  'Чи легко Вам відстоювати свою позицію перед іншими?',
  'Чи вдавалося Вам захопити своєю ідеєю інших?',
  'Чи легко Вам знаходити товар в супермаркеті?',
  'Чи любите Ви готувати?',
  'Чи приваблює Вас ІТ індустрія?',
  'Чи любите Ви подорожувати?',
];
